import {Trans, useTranslation} from "react-i18next";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap";
import ValluLogoSvg from "../images/_Vallu_musta.svg";
import React from "react";

export default function Saavutettavuusseloste() {
  const { t } = useTranslation("common");
  return (
    <>
      <main className="container-fluid">
        <section className="row">
          <Col />
          <Col xs={10}>
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to="/">{t("frontPage")} </Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>{t("accessibilityInfo.link")}</BreadcrumbItem>
            </Breadcrumb>
            <div className="mb-5">
              <h1>{t("accessibilityDocument.title")}</h1>
              <p>{t("accessibilityDocument.infoBody")}</p>
              <h2>{t("accessibilityDocument.accessibilityState.title")}</h2>
              <p>{t("accessibilityDocument.accessibilityState.body")}</p>
              <div className="mb-5">
                <h2>{t("accessibilityDocument.contact.title")}</h2>
                <p>{t("accessibilityDocument.contact.body")}</p>
              </div>
              <div className="mb-5">
                <h2>{t("accessibilityDocument.accessibilityAuthority.title")}</h2>
                <p>{t("accessibilityDocument.accessibilityAuthority.body")}</p>
                <h3>{t("accessibilityDocument.accessibilityAuthority.contactInfo.title")}</h3>
                <p>{t("accessibilityDocument.accessibilityAuthority.contactInfo.body")}</p>
              </div>

            </div>
            <div className="mb-5">
              <h2>{t("accessibilityDocument.notAccessibleContent.title")}</h2>
              <p>{t("accessibilityDocument.notAccessibleContent.body")}</p>
              <div className="mb-5">
                <h3>{t("accessibilityDocument.notAccessibleContent.textEquivalents.title")}</h3>
                <h4>{t("accessibilityDocument.notAccessibleContent.shortcomingsTitle")}</h4>
                <p>{t("accessibilityDocument.notAccessibleContent.textEquivalents.shortcomingsText")}</p>
                <h4>{t("accessibilityDocument.notAccessibleContent.requirementsNotMetTitle")}</h4>
                <p>{t("accessibilityDocument.notAccessibleContent.textEquivalents.requirementsNotMetText")}</p>
              </div>
              <div className="mb-5">
                <h3>{t("accessibilityDocument.notAccessibleContent.cantDisplayAllContent.title")}</h3>
                <h4>{t("accessibilityDocument.notAccessibleContent.shortcomingsTitle")}</h4>
                <p>{t("accessibilityDocument.notAccessibleContent.cantDisplayAllContent.shortcomingsText")}</p>
                <h4>{t("accessibilityDocument.notAccessibleContent.requirementsNotMetTitle")}</h4>
                <p>{t("accessibilityDocument.notAccessibleContent.cantDisplayAllContent.requirementsNotMetText")}</p>
              </div>
              <div className="mb-5">
                <h3>{t("accessibilityDocument.notAccessibleContent.contrastAndDisplaySize.title")}</h3>
                <h4>{t("accessibilityDocument.notAccessibleContent.shortcomingsTitle")}</h4>
                <p>{t("accessibilityDocument.notAccessibleContent.contrastAndDisplaySize.shortcomingsText")}</p>
                <h4>{t("accessibilityDocument.notAccessibleContent.requirementsNotMetTitle")}</h4>
                <p>
                  <ul>
                    {[...Array(4).keys()].map((key) => (
                        <li key={`accessibilityDocument.notAccessibleContent.contrastAndDisplaySize.requirementsNotMetText.${key}`}>
                          <Trans
                              defaults={t(`accessibilityDocument.notAccessibleContent.contrastAndDisplaySize.requirementsNotMetText.${key}`)}
                          />
                        </li>
                    ))}
                  </ul>
                </p>
              </div>
              <div className="mb-5">
                <h3>{t("accessibilityDocument.notAccessibleContent.keyboardAccessibility.title")}</h3>
                <h4>{t("accessibilityDocument.notAccessibleContent.shortcomingsTitle")}</h4>
                <p>{t("accessibilityDocument.notAccessibleContent.keyboardAccessibility.shortcomingsText")}</p>
                <h4>{t("accessibilityDocument.notAccessibleContent.requirementsNotMetTitle")}</h4>
                <p>{t("accessibilityDocument.notAccessibleContent.keyboardAccessibility.requirementsNotMetText")}</p>
              </div>
              <div className="mb-5">
                <h3>{t("accessibilityDocument.notAccessibleContent.navigateAccessibility.title")}</h3>
                <h4>{t("accessibilityDocument.notAccessibleContent.shortcomingsTitle")}</h4>
                <p>{t("accessibilityDocument.notAccessibleContent.navigateAccessibility.shortcomingsText")}</p>
                <h4>{t("accessibilityDocument.notAccessibleContent.requirementsNotMetTitle")}</h4>
                <p>
                  <ul>
                    {[...Array(6).keys()].map((key) => (
                        <li key={`accessibilityDocument.notAccessibleContent.navigateAccessibility.requirementsNotMetText.${key}`}>
                          <Trans
                              defaults={t(`accessibilityDocument.notAccessibleContent.navigateAccessibility.requirementsNotMetText.${key}`)}
                          />
                        </li>
                    ))}
                  </ul>
                </p>
              </div>
              <div className="mb-5">
                <h3>{t("accessibilityDocument.notAccessibleContent.textContentReadability.title")}</h3>
                <h4>{t("accessibilityDocument.notAccessibleContent.shortcomingsTitle")}</h4>
                <p>{t("accessibilityDocument.notAccessibleContent.textContentReadability.shortcomingsText")}</p>
                <h4>{t("accessibilityDocument.notAccessibleContent.requirementsNotMetTitle")}</h4>
                <p>
                  <ul>
                    {[...Array(2).keys()].map((key) => (
                        <li key={`accessibilityDocument.notAccessibleContent.textContentReadability.requirementsNotMetText.${key}`}>
                          <Trans
                              defaults={t(`accessibilityDocument.notAccessibleContent.textContentReadability.requirementsNotMetText.${key}`)}
                          />
                        </li>
                    ))}
                  </ul>
                </p>
              </div>
              <div className="mb-5">
                <h3>{t("accessibilityDocument.notAccessibleContent.navigatingNotLogical.title")}</h3>
                <h4>{t("accessibilityDocument.notAccessibleContent.shortcomingsTitle")}</h4>
                <p>{t("accessibilityDocument.notAccessibleContent.navigatingNotLogical.shortcomingsText")}</p>
                <h4>{t("accessibilityDocument.notAccessibleContent.requirementsNotMetTitle")}</h4>
                <p>{t("accessibilityDocument.notAccessibleContent.navigatingNotLogical.requirementsNotMetText")}</p>
              </div>
              <div className="mb-5">
                <h3>{t("accessibilityDocument.notAccessibleContent.pageCompatibility.title")}</h3>
                <h4>{t("accessibilityDocument.notAccessibleContent.shortcomingsTitle")}</h4>
                <p>{t("accessibilityDocument.notAccessibleContent.pageCompatibility.shortcomingsText")}</p>
                <h4>{t("accessibilityDocument.notAccessibleContent.requirementsNotMetTitle")}</h4>
                <p>
                  <ul>
                    {[...Array(3).keys()].map((key) => (
                        <li key={`accessibilityDocument.notAccessibleContent.pageCompatibility.requirementsNotMetText.${key}`}>
                          <Trans
                              defaults={t(`accessibilityDocument.notAccessibleContent.pageCompatibility.requirementsNotMetText.${key}`)}
                          />
                        </li>
                    ))}
                  </ul>
                </p>
              </div>

            </div>

            <div className="mb-5">
              <Link to="/">{t("toFrontPage")} </Link>
            </div>
          </Col>
          <Col />
        </section>
      </main>
      <footer className="container-fluid">
        <Row
          className="py-4"
          style={{ paddingTop: "3rem", paddingBottom: "3rem" }}>
          <Col className="h-100 align-self-end">
            <img
              alt=""
              className="img-fluid"
              src={ValluLogoSvg}
              style={{ height: "3rem" }}
            />
          </Col>
          <Col />
          <Col className="h-100 align-self-end text-end">
            <p className="mb-0">&copy; {new Date().getFullYear()} Metropolia</p>
          </Col>
        </Row>
      </footer>
    </>
  );
}
